<fadv-box>
    <form [formGroup]="paymentExtra" (keydown.enter)="$event.preventDefault()">
        <fadv-grid>
            <fadv-grid-row>
                <fadv-grid-col alignment="left">
                    <fadv-typography type="label-medium" weight="500">Card Holder Address Information</fadv-typography>
                </fadv-grid-col>
            </fadv-grid-row>
            <fadv-grid-row>
                <fadv-grid-col [col]="{ lg: 6, xs: 12 }" alignment="left">
                    <fadv-input             
                        [invalid]="this.ccaddressInvalid"
                        (blur)="showValidation('ccaddress')"
                        formControlName="ccaddress" 
                        type="text" 
                        label="Street Address *"
                        required
                        (keydown.enter)="$event.preventDefault()">
                    </fadv-input>
                </fadv-grid-col>
                <fadv-grid-col [col]="{ lg: 6, xs: 12 }" alignment="left">
                    <fadv-input
                        [invalid]="this.cccityInvalid"
                        (blur)="showValidation('cccity')"  
                        formControlName="cccity" 
                        type="text"
                        label="City *"
                        required
                        (keydown.enter)="$event.preventDefault()">
                </fadv-input>
                </fadv-grid-col>
            </fadv-grid-row>
            <fadv-grid-row>
                <fadv-grid-col [col]="{ lg: 6, xs: 12 }" alignment="left">
                    <fadv-input 
                        [invalid]="this.ccpostalInvalid"
                        (blur)="showValidation('ccpostal')"
                        (blur)="getStateByZip()"
                        formControlName="ccpostal" 
                        label="Zip Code *"
                        [maxlength]="5"
                        required
                        (keydown.enter)="$event.preventDefault()">
                    </fadv-input>
                    <small *ngIf="this?.paymentExtra?.get('ccpostal').hasError('minLength') || this?.paymentExtra?.get('ccpostal').hasError('pattern')">
                        Zip Code must be 5 numbers
                    </small>
                </fadv-grid-col>
                <fadv-grid-col [col]="{ lg: 6, xs: 12 }" alignment="left">
                    <fadv-input 
                        [invalid]="this.ccregionInvalid"
                        (blur)="showValidation('ccregion')"
                        formControlName="ccregion" 
                        type="text"
                        label="State Code *"
                        [maxlength]="2" 
                        [minlength]="2"
                        required
                        (keydown.enter)="$event.preventDefault()">
                    </fadv-input>
                    <span class="error" *ngIf="this.ccregionInvalid">
                        <small *ngIf="paymentExtra.get('ccregion').hasError('required')">
                            State Code is Required
                        </small>
                        <small *ngIf="paymentExtra.get('billToState').hasError('pattern')">
                            State must be two letters
                        </small>
                    </span>
                </fadv-grid-col>
            </fadv-grid-row>
        </fadv-grid>
    </form>
</fadv-box>

<div class="spinnerContainer"  *ngIf="loading == true">
    <fadv-loader open="true" [duration]="2200" #loader ></fadv-loader>
</div>